import styled from 'styled-components'
import { InputDivProps } from './interface'

export const InputStld = styled.input<InputDivProps>`
  height: ${({ height }) => height || '56px;'};
  width: ${({ width }) => width || '100%;'};
  font-size: ${({ fontsize }) => fontsize || '36px;'};
  text-align: ${({ textcenter }) => textcenter || 'left;'};
  text-overflow: ${({ textOverflow }) => textOverflow || 'unset'};
  margin: ${({ margin }) => margin || '0;'};
  overflow: ${({ overflow }) => overflow || 'unset'};
  border-radius: ${({ radius }) => radius || '0px'};
  border: ${({ borderColor }) =>
    borderColor ? `3px solid ${borderColor}` : 'none'};
  background: ${({ innerBackground }) => innerBackground || 'transparent'};
  padding: ${({ padding }) => padding || '0px 5px'};
  color: #ffb000;
  overflow: hidden;
  text-overflow: ellipsis;
  ::placeholder {
    color: #ffb000;
  }
  :focus {
    background: ${({ focusColor }) => focusColor || 'transparent'};
  }
`

export const InputBox = styled.span<InputDivProps>`
  display: flex;
  justify-content: flex-start;
  position: relative;
  height: ${({ height }) => height || '56px;'};
  width: ${({ width }) => width || '100%;'};
  span {
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 2;
    height: 100%;
    padding: ${({ padding }) => padding};
  }
`
